
@switch (columnId) {
  @case ('id') {
    <lib-text-table-column>
      {{ element.id }}
    </lib-text-table-column>
    <lib-table-column-sort [key]="element.id ?? 0"></lib-table-column-sort>
  }
  @case ('url') {
    <lib-text-table-column>
      {{ element.url }}
    </lib-text-table-column>
  }
  @case ('active') {
    <span (mousedown)="stopPropagation($event)" (mouseup)="stopPropagation($event)">
      <lib-vitu-slide-toggle
        [checked]="element.isActive"
        (checkedChange)="isActiveToggled($event)"
        [disabled]="toggleWebhookLoading">
      </lib-vitu-slide-toggle>
    </span>
  }
  @case ('solution') {
    {{ getDisplayTextForSolution() }}
  }
  @default {
  }
}





